import { createFileRoute } from "@tanstack/react-router";

import { Notifications } from "@/features/office/notifications";

export const Route = createFileRoute("/office/notifications/")({
  component: Notifications,
});
